/**
 * Relay Utils
 */

import { environment } from '../relay';

import { extend } from 'lodash';
import { commitMutation } from 'react-relay';

export interface Edge<N> {
  node: N | null;
}

export interface Connection<N> {
  edges: Array<Edge<N>> | null;
}

const defaultList = [];

export function extractNodeFromConnection<N>(connection: Connection<N>) {
  return connection.edges ? connection.edges.map<N>(({ node }) => node!) : defaultList;
}

export interface RelayOperationBase<Variables, Response> {
  variables: Variables;
  response: Response;
}

export interface RelayMutation<TInput> {
  variables: {
    input: TInput;
  };
  response: GQL.IMutation;
}

interface IRelayAddConfig {
  type?: 'RANGE_ADD';
  parentID: string;
  connectionInfo: Array<{
    key: string;
    rangeBehavior: 'append' | 'prepend' | 'ignore';
  }>;
  edgeName: string;
}

interface IRelayDeleteConfig {
  type?: 'RANGE_DELETE' | 'NODE_DELETE';
  parentID: string;
  pathToConnection: string[];
  connectionKeys: Array<{ key: string }>;
  deletedIDFieldName?: string;
}

export function processAddMutation<TInput>(mutation, input: TInput, config: IRelayAddConfig) {
  const baseConfig: Partial<IRelayAddConfig> = {
    type: 'RANGE_ADD',
  };

  return processMutation<TInput>(mutation, input, [extend(baseConfig, config)]);
}

export function processDeleteMutation<TInput>(mutation, input: TInput, config: IRelayDeleteConfig) {
  const baseConfig = {
    type: 'RANGE_DELETE',
    deletedIDFieldName: 'deleted_id',
  };

  return processMutation<TInput>(mutation, input, [extend(baseConfig, config)]);
}

export function processMutation<TInput>(
  mutation,
  input: TInput,
  configs?: any[],
  updater?: (storeProxy, errors) => void,
) {
  return new Promise<IMutationResult>((resolve, reject) => {
    commitMutation<RelayMutation<TInput>>(environment, {
      mutation,
      variables: { input },
      configs,
      updater,
      onCompleted: (response, errors) => resolve({ response, errors }),
      onError: reject,
    });
  });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/utils/relay.ts